import { Popover, Theme } from "@mui/material";
import { createStyles, withStyles, WithStyles } from "@mui/styles";
import { UserIdResolver, UsernameResolver } from "components/UsernameInspect";
import { UserEntityModel, UserShortView } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import Session from "services/Session";
import UserShortProfile from "views/User/Components/UserShortProfile";

interface IProps {
    user: UserEntityModel | UserShortView;
    firstNameOnly?: boolean;
    inheritColor?: boolean;
}

interface IState {
    dialog: any;
    open: boolean;
}

const styles = (theme: Theme) => createStyles({
    inheritColor: {
        color: "inherit"
    },
    ordinary: {
        ...theme.genie.user.ordinary.styles
    },
    sysuser: {
        ...theme.genie.user.sysUser.styles
    }

});

type Props = IProps & WithTranslation & WithStyles<typeof styles>;

class UserProfileLink extends React.Component<Props, IState>
{
    constructor(props: Props) {
        super(props);
        this.state = { dialog: null, open: false };
    }

    private popperActions: any;
    private popperRef: any;

    render() {

        if (this.props.user == null)
            return null;

        if (this.props.user.isSystemUser === true)
            return <span className={this.props.inheritColor === true ? this.props.classes.inheritColor : this.props.classes.ordinary}>Sistema</span>;

        const { t } = this.props;
        const firstNameOnly = this.props.firstNameOnly || false;
        const id = UserIdResolver(this.props.user);
        const name = UsernameResolver(this.props.user, firstNameOnly);

        if (id == Session.user.id || id == Session.tenantId)
            return <b>{name}</b>;

        return (
            <>
                <a
                    className={this.props.inheritColor === true ? this.props.classes.inheritColor : this.props.classes.ordinary}
                    href="#"
                    ref={(ref) => this.popperRef = ref}
                    title={t("Components.UserProfileImageLink.TitleText")}
                    onClick={(e) => { e.preventDefault(); this.setState({ open: true }); }}
                >
                    {name}
                </a>

                <Popover
                    action={(actions: any) => this.popperActions = actions}
                    open={this.state.open}
                    anchorEl={this.popperRef}
                >
                    <UserShortProfile
                        userId={id}
                        onClose={() => this.setState({ open: false })}
                        onLoadComplete={() => {
                            if (this.popperActions) {
                                this.popperActions.updatePosition();
                            }
                        }}
                    />
                </Popover>
            </>
        );
    }
}

export default withTranslation()(withStyles(styles)(UserProfileLink));
